module.exports = __webpack_public_path__ + "static/media/6TipsForEmployeestoWorkFromHomeEfficiently.b0837926.png";